import { checkoutUserErrorFragment } from './fragmentGeneral.gql';
import checkoutFragment from './fragmentCheckout.gql';

/*
	checkoutId
		ID! required
    The ID of the checkout.

	discountCode
		String! required
    The discount code to apply to the checkout.
*/

const checkoutDiscountCodeApplyV2 = (
	`mutation ($checkoutId: ID!, $discountCode: String!) {
		checkoutDiscountCodeApplyV2(checkoutId: $checkoutId, discountCode: $discountCode) {
			checkoutUserErrors ${checkoutUserErrorFragment}
			checkout ${checkoutFragment}
		}
	}`
);

export default checkoutDiscountCodeApplyV2;
